import {InteractiveScene} from '@/components/player-v2/InteractiveVoting/types';

export const WR_INTERACTIVE_SCENES_2: {[ts: number]: InteractiveScene} = {
  50: {
    timestamp: 50,
    name: 'Episode 1',
    videoUrl:
      'https://stream.mux.com/7WyMoOetfGct4EdfD006qS6U718ZoSbApS1nj82afjsg.m3u8',
    options: {
      1: {
        id: 1,
        key: 'left',
        text: 'Take the door to the left',
        description: {
          text: 'Audience choice | 70%',
          x: 0.25,
          y: 0.25,
        },
        cutsceneHasControls: true,
        cutsceneHasProgressBar: true,
        choiceOverlayVideoUrl:
          'https://stream.mux.com/OaGII012SeDsHbf01LYlyiqViUH6FonR02bTCMmrPjXEu4.m3u8',
        cutsceneVideoUrl:
          'https://stream.mux.com/887VzFSjLY1Ko02BAmPsRg00efSKtOXKi4ypXFk5qYZ3M.m3u8',
      },
      2: {
        id: 2,
        key: 'right',
        description: {
          text: '30% voted for this',
          x: 0.68,
          y: 0.25,
        },
        cutsceneHasControls: true,
        cutsceneHasProgressBar: true,
        text: 'Take the door to the right',
        choiceOverlayVideoUrl:
          'https://stream.mux.com/QEE02Uum6H8GwoWdJp73ckPemDNGAalPJNh6a9QqEsTE.m3u8',
        cutsceneVideoUrl:
          'https://stream.mux.com/niE7ghDN95BvOTMISZmu0101eDIFt01Zu3voMYer5fWnPU.m3u8',
      },
    },
  },
  // 3:32
  212: {
    timestamp: 212,
    name: 'Episode 2',
    videoUrl:
      'https://stream.mux.com/rtDVDf5pMGSaMQeaT8h2hq465FW2vLgKfBpTSiVoemA.m3u8',
    audioUrl:
      'https://storage.googleapis.com/shibuya-white-rabbit/WhiteRabbit_Idle_Ambient_2.mp4',
    options: {
      1: {
        id: 1,
        key: 'left',
        text: 'Follow the fox',
        description: {
          text: 'Audience choice | 41%',
          x: 0.15,
          y: 0.6,
        },
        cutsceneHasControls: true,
        cutsceneHasProgressBar: true,
        choiceOverlayVideoUrl:
          'https://stream.mux.com/1kHctSlMcELfRpRSohsrKK9k020168JQvx5ZW7yFTQbsI.m3u8',
        cutsceneVideoUrl:
          'https://stream.mux.com/xqW1dwojPQZs15pBscW5XQo00E6NR900oB6cySLW9Z300s.m3u8',
        audioUrl:
          'https://storage.googleapis.com/shibuya-white-rabbit/ch-2-fox.mp3',
        audioSubtitle: "She's here. We need to go.",
      },
      2: {
        id: 2,
        key: 'center',
        text: 'Go to the drop',
        description: {
          text: '38% of the vote',
          x: 0.42,
          y: 0.3,
        },
        cutsceneHasControls: true,
        cutsceneHasProgressBar: true,
        choiceOverlayVideoUrl:
          'https://stream.mux.com/TUAfHGr6QDPjaGnNQEiWjyoV4Gr8zRTFgNnZQl5vvro.m3u8',
        cutsceneVideoUrl:
          'https://stream.mux.com/JFaHA8nFlAeANeAM4opNJrn99SpQ9b01rz1OiJv01Bjp00.m3u8',
        audioSubtitle: '???',
      },
      3: {
        id: 3,
        key: 'right',
        text: 'Follow the lady',
        description: {
          text: '21% of the vote',
          x: 0.75,
          y: 0.3,
        },
        cutsceneHasControls: true,
        cutsceneHasProgressBar: true,
        choiceOverlayVideoUrl:
          'https://stream.mux.com/AoheoyAvFmtyyktT5ydMmb3g7SxdvxAjLd02BCHdQX94.m3u8',
        cutsceneVideoUrl:
          'https://stream.mux.com/02wLcJUGOpSiPyJ0001pl6bWlBo1Gwo95t6VPNE5EGK18E.m3u8',
        audioUrl:
          'https://storage.googleapis.com/shibuya-white-rabbit/ch-2-lady.mp3',
        audioSubtitle: 'Let me show you something.',
      },
    },
  },
  1292.4: {
    timestamp: 1292.4,
    name: 'Do you have a White Rabbit Key?',
    videoUrl:
      'https://stream.mux.com/XErdnHllXxNl8eKuDolgZ4JJpHCX2HFhQu6GnNZLc4s.m3u8',
    type: 'bandersnatch',
    unskippable: true,
    options: {
      1: {
        id: 1,
        key: 'yes',
        text: 'Yes',
        onSelect: {
          type: 'openModal',
          modal: 'checkKey',
          onSuccess: 'endInteraction',
        },
        cutsceneHasControls: true,
        cutsceneHasProgressBar: true,
        endInteractionOnSelect: true, // After the cutscene plays, the interaction ends
        cutsceneVideoUrl:
          'https://stream.mux.com/f9i5w3fTldQwFtZ0137NRlmt6xGkQm7zofkR5cShVF7M.m3u8',
      },
      2: {
        id: 2,
        key: 'no',
        text: 'No',
        cutsceneHasControls: true,
        cutsceneHasProgressBar: true,
        endInteractionOnSelect: true, // After the cutscene plays, the interaction ends
        cutsceneVideoUrl:
          'https://stream.mux.com/SxZDPsSmZ4PaoTBInlboYOhjetvfB2ZhRHBw9o2muuM.m3u8',
      },
    },
  },
  1352.4: {
    // 23:04
    timestamp: 1352.4,
    name: 'Take the hat?',
    videoUrl:
      'https://stream.mux.com/j82WLLlPJqUL69N49nnQxJC2JD02HBaTZZU5f3Reyed4.m3u8',
    type: 'bandersnatch',
    unskippable: true,
    options: {
      1: {
        id: 1,
        key: 'yes',
        text: 'Yes',
        endInteractionOnSelect: true,
        cutsceneVideoUrl: '',
      },
      2: {
        id: 2,
        key: 'no',
        text: 'No',
        skipToTsOnEnd: 0,
        cutsceneHasControls: false,
        cutsceneHasProgressBar: false,
        endInteractionOnSelect: true,
        cutsceneVideoUrl:
          'https://stream.mux.com/Sj3FYHET9eqGRlB5ixYmxIV201kyyqPXdUBkcgmvL01lI.m3u8',
      },
    },
  },
};
